import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get, api_post } from "api/utils"
import { CursorType } from "utils/types"
export type ChatRoomType = {
    key: string;
    uuid: string;
    identity: string;
    team: string;
    name: string;
    description: string;
    visibility: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: ChatRoomType) => void;
};

// Domain object ChatRoom
export class ChatRoom implements ChatRoomType {
    key = "";
    uuid = "";
    identity = "";
    team = "";
    name = "";
    description = "";
    visibility = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: ChatRoomType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: ChatRoomType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class ChatRoomStore extends BaseStore<ChatRoomType, ChatRoom> {

    async createChatRoom(
        identity: string,
        name: string,
        description: string,
        visibility: string
    ) {
        const data = { identity, name, description, visibility };
        const response = await api_post("/chat-room/create", data);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    async fetchList(identity: string, cursor?: CursorType): Promise<ChatRoomType[]>  {
        const url = "/chat-room/list";
        const data = { identity, cursor: cursor || '' };
        const response = await api_get(url, data);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchList(identity, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but ChatRoomStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    async fetchChatRoom(uuid: string) {
        const response = await api_get(`/chat-room/get?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }



    modelConstructor() {
        return ChatRoom;
    }

}
